<template>
    <v-app class="app-container" :id="isTheme1 ? 'theme1' : ''">
        <template v-if="showPage">
            <router-view/>
        </template>
        <div v-else></div>
    </v-app>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
    name: "App",
    components: {},
    data() {
        return {
            showPage: false
        };
    },
    computed: {
        ...mapState([
            "isTheme1"
        ])
    },
    mounted() {
        if(sessionStorage.getItem('isTheme1')){
            this.setTheme1();
        }
        this.showPage = true;
    },
    methods: {
        ...mapMutations([
            "setTheme1"
        ]),
    }
};
</script>

<style scoped lang="sass" src="./app.sass"></style>
<style lang="sass" src="./theme1.sass"></style>
